"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VEHICLE_INSURANCE_MAX_VALIDITY_YEARS = void 0;
exports.isVehicleInsuranceDocumentType = isVehicleInsuranceDocumentType;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function isVehicleInsuranceDocumentType(documentType) {
    if (!documentType?.englishName) {
        return false;
    }
    // all variations of vehicle insurance document types we have in the database for different countries
    const vehicleInsuranceEnglishNames = [
        "Third-party insurance, green card",
        "Third-party insurance, memo insurance",
        // TODO(mg): wait for DS confirmation we need to include this one as well
        "Insurance Certificate covering use of your vehicle as an SPSV",
    ];
    return (documentType.subject === legacy_enums_1.DocumentSubject.Vehicle &&
        vehicleInsuranceEnglishNames.some((name) => documentType.englishName.toLowerCase().includes(name.toLowerCase())));
}
exports.VEHICLE_INSURANCE_MAX_VALIDITY_YEARS = 2;
//# sourceMappingURL=documentType.js.map